import React from 'react'
import { CardHeader, Card, CardContent } from '@material-ui/core'
import PropTypes from 'prop-types'
import useTeamFeature from 'hooks/useTeamFeature'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import { useCardStyles, Heading } from '../styles'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const PlayersListCard = ({ title, children }) => {
  const classes = useCardStyles()

  const { enabled: hasCreateGeneralEventEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.create_general_event_enabled
  )

  return (
    <Card className={classes.root}>
      <CardHeader
        title={
          <Heading variant="h4" component="h4">
            {title}{' '}
            {!hasCreateGeneralEventEnabled && (
              <LockIconComponent context="primaryButton" />
            )}
          </Heading>
        }
      />
      <CardContent>{children}</CardContent>
    </Card>
  )
}

PlayersListCard.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
}
export default PlayersListCard
